import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { UserTypeEnum } from '@enums/user-type.enum';
import { ApplicationModules } from '@enums/application-modules.enum';
import { MenuConfigModel } from '@core/models/outros/menu-config.model';

export const MENU_THEORETICAL_COURSE: MenuConfigModel = {
  id: ApplicationModules.THEORETICAL_COURSE,
  icon: 'school',
  name: 'Curso Teórico',
  onlyAssociated: true,
  text: 'Organize a <strong>agenda</strong>, as <strong>aulas teóricas</strong>, além de cadastrar <strong>cursos</strong> e <strong>grades</strong>.',
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.OPERADOR_N1,
    UserTypeEnum.INSTRUTOR,
    UserTypeEnum.SUPERVISOR
  ],
  submenus: [
    {
      name: 'Grade',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1,
        UserTypeEnum.INSTRUTOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.theoretical_course.path}/${ROUTES_APLICATION.theoretical_course.grid}`,
    },
    {
      name: 'Grade Serviço',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.theoretical_course.path}/${ROUTES_APLICATION.theoretical_course.serviceGrid}`,
    },
    {
      name: 'Teórico',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1,
        UserTypeEnum.INSTRUTOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.theoretical_course.path}/${ROUTES_APLICATION.theoretical_course.theory}`,
    },

  ],
}
